import {Fragment, useEffect, useState} from 'react'
import {Button, Col, Form, Row} from 'react-bootstrap'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'
import useServices from '../../../../../utils/hooks/useServices'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'

const FormCompany = () => {
  const navigate = useNavigate()
  const [counter, setCounter] = useState(1)
  const [submit, setSubmit] = useState(false)
  const [formValue, setFormValue] = useState<any>({
    company_email: '',
    company_size_id: '',
    city_id: '',
    postal_code: '',
    company_name: '',
    company_address: '',
    company_website: '',
    company_year_founded: '',
    company_overview: '',
    document_mou: '',
    document_introduction_and_requirements: '',
    company_pic: '',
    company_pic_code_phone: '',
    company_pic_position: '',
    company_code_phone: '',
    company_phone: '',
    industries: '',
    languages: '',
    ownership_id: '',
  })
  const [profile, loadingProfile, emptyProfile, refreshProfile, isErrorProfile, setLoadingProfile] =
    useServices(
      MasterServices.getCompanyProfile,
      null,
      []
    )
  const [
    ownerships,
    loadingOwnerships,
    emptyOwnerships,
    refreshOwnerships,
    isErrorOwnerships,
    setLoadingOwnerships,
  ] = useServices(
    MasterServices.getOwnership,
    {page: 1, sort_field: 'created_at', per_page: 1000},
    []
  )

  const [cities, loadingCities, emptyCities, refreshCities, isErrorCities, setLoadingCities] =
    useServices(
      MasterServices.getCity,
      {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
      []
    )
  const [
    industries,
    loadingIndustries,
    emptyIndustries,
    refreshIndustries,
    isErrorIndustries,
    setLoadingIndustries,
  ] = useServices(
    MasterServices.getIndustry,
    {page: 1, sort_field: 'created_at', per_page: 1000, is_active: 1},
    []
  )
  const [size, loadingSize, emptySize, refreshSize, isErrorSize, setLoadingSize] = useServices(
    MasterServices.getCompanySize,
    {page: 1, sort_field: 'created_at', per_page: 1000},
    []
  )
  const [inputs, setInputs] = useState([
    {
      name: 'company_name',
      label: 'Nama Perusahaan*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'ownership_id',
      label: 'Kepemilikan*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'company_overview',
      label: 'Tentang Perusahaan*',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_address',
      label: 'Alamat Perusahaan*',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'city_id',
      label: 'Kota/Kabupaten*',
      type: 'select2',
      validation: {},
      col: 12,
      options: cities || [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'company_website',
      label: 'Alamat Website Perusahaan (eg: https://lpdp.kemenkeu.go.id)',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_link_video_profile',
      label: 'Link Video Company Profil (eg: https://lpdp.kemenkeu.go.id)',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_size_id',
      label: 'Jumlah Karyawan*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_sizes_name',
      getItemValueId: 'company_sizes_id',
    },
    {
      name: 'postal_code',
      label: 'Kode POS*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'company_sizes_name',
      getItemValueId: 'company_sizes_id',
    },
    {
      name: 'industries',
      label: 'Tipe Industri*',
      type: 'select2',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'company_year_founded',
      label: 'Tahun Perusahaan Didirikan*',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_phone',
      label: 'No Telpon Perusahaan*',
      type: 'number',
      validation: {},
      col: 3,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic',
      label: 'Nama PIC*',
      type: 'text',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_phone',
      label: 'No Telpon PIC*',
      type: 'number',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_email',
      label: 'Email PIC',
      type: 'email',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
    {
      name: 'company_pic_position',
      label: 'Posisi PIC*',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
      getItemValue: '',
      getItemValueId: '',
    },
  ])

  useEffect(() => {
    let clone = inputs
    if (profile) {
      const companyData = profile?.data
      setFormValue({
        ...formValue,
        company_email: companyData?.companies_name,
        company_size_id: companyData?.company_size,
        city_id: companyData?.city,
        postal_code: companyData?.companies_postal_code,
        company_name: companyData?.companies_name,
        company_address: companyData?.companies_address,
        company_website: companyData?.companies_website,
        company_link_video_profile: companyData?.companies_link_video_profile,
        company_year_founded: companyData?.companies_year_founded,
        company_overview: companyData?.companies_overview,
        document_mou: '',
        document_introduction_and_requirements: '',
        company_pic: companyData?.companies_pic,
        company_pic_email: companyData?.companies_pic_email,
        company_pic_phone: companyData?.companies_pic_phone,
        company_pic_position: companyData?.companies_pic_position,
        company_pic_code_phone: companyData?.companies_pic_code_phone,
        company_code_phone: companyData?.companies_code_phone,
        company_phone: companyData?.companies_phone,
        industries: companyData?.industry,
        languages: companyData?.language,
        ownership_id: profile?.data?.company_ownership,
      })
    }
    if (ownerships) {
      clone[1].options = ownerships?.data?.data
    }

    if (cities) {
      clone[4].options = cities?.data?.data
    }

    if (size) {
      clone[7].options = size?.data?.data
    }

    if (industries) {
      clone[9].options = industries?.data?.data
    }

    setInputs(clone)
    setCounter((val) => val + 1)
  }, [cities, industries, ownerships, size])

  const handleChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleSubmit = async (e: any) => {
    try {
      e?.preventDefault()
      setSubmit(true)
      await MasterServices.updateCompanyProfile({
        ...formValue,
        ownership_id: formValue?.ownership_id?.company_ownerships_id,
        country_id: formValue?.country_id?.countries_id,
        city_id: formValue?.city_id?.cities_id,
        industries: formValue?.industries?.industries_id,
        company_size_id: formValue?.company_size_id?.company_sizes_id,
        languages: formValue?.languages?.languages_id,
      })
      toast.success('Informasi Perusahaan berhasil diperbarui.')

      navigate('/crafted/pages/profile/company-overview')
    } catch (error) {
    } finally {
      setSubmit(false)
    }
  }
  return (
    <Fragment>
      <Row>
        <Col md={12}>
          <Form onSubmit={handleSubmit}>
            <div className='card-custom'>
              <Row className='mb-8'>
                {counter && FormGenerator(inputs, formValue, handleChange, null, submit)}
                {/* <Col md={12}>
                  <Form.Label>
                    Upload Document MoU dengan LPDP (download template MoU disini)*
                  </Form.Label>
                  <br />
                  <Button>Attach Files</Button>
                </Col>
                <Col md={12}>
                  <Form.Label>
                    Upload Surat Pengantar dan Persyaratan Lowongan Kerja yang Ingin Dibuka*
                  </Form.Label>
                  <br />
                  <Button>Attach Files</Button>
                </Col> */}
              </Row>
            </div>
            <div className='mt-8' style={{float: 'right'}}>
              <Button
                variant='secondary'
                type='button'
                disabled={submit}
                onClick={() => navigate('/dashboard')}
              >
                Batal
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button className='ml-6' type='submit' disabled={submit}>
                Perbarui
              </Button>
            </div>
            <br />
            <br />
            <br />
            <br />
          </Form>
        </Col>
      </Row>
    </Fragment>
  )
}

export default FormCompany
